export enum PunishmentEnum {
  BAN = 'BAN',
  ADMONISH = 'ADMONISH',
}
